<template>
  <div>
    <el-popover placement="bottom" width="350" :close-delay="50" trigger="hover">
      <!-- 内容 -->
      <div>
        <el-tabs v-model="activeName" @tab-click="tabChange" stretch style="padding: 0 10px;">
          <el-tab-pane key="toDo" label="待办消息" name="toDo">
            <template v-if="toDoList && toDoList.length">
              <div v-for="(item, index) in toDoList" :key="index" class="message-item"
                @click="openMessageDeatilDialog(item)">
                <span class="el-icon-suitcase"></span>
                <div class="item-right">
                  <div class="item-right-contentBox">
                    <el-tag v-if="item.status == '0'" class="tag" size="mini" type="danger">未读</el-tag>
                    <div v-text="getHtmlText(item.content)" class="content"></div>
                  </div>
                  <div class="item-right-time">
                    {{ item.sendTime }}
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <div
                style="min-height: 200px;font-size: 18px;color: #909399;display: flex;justify-content: center;align-items: center;">
                <span class="el-icon-info" style="font-size: 22px;margin-right: 5px;"></span>
                暂无待办消息
              </div>
            </template>
          </el-tab-pane>
          <el-tab-pane key="bus" label="业务消息" name="bus">
            <template v-if="busList && busList.length">
              <div v-for="(item, index) in busList" :key="index" class="message-item"
                @click="openMessageDeatilDialog(item)">
                <span class="el-icon-message"></span>
                <div class="item-right">
                  <div class="item-right-contentBox">
                    <el-tag v-if="item.status == '0'" class="tag" size="mini" type="danger">未读</el-tag>
                    <div v-text="getHtmlText(item.content)" class="content"></div>
                  </div>
                  <div class="item-right-time">
                    {{ item.sendTime }}
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <div
                style="min-height: 200px;font-size: 18px;color: #909399;display: flex;justify-content: center;align-items: center;">
                <span class="el-icon-info" style="font-size: 22px;margin-right: 5px;"></span>
                暂无业务消息
              </div>
            </template>
          </el-tab-pane>
          <el-tab-pane key="sys" label="系统消息" name="sys">
            <template v-if="sysList && sysList.length">
              <div v-for="(item, index) in sysList" :key="index" class="message-item"
                @click="openMessageDeatilDialog(item)">
                <span class="el-icon-date"></span>
                <div class="item-right">
                  <div class="item-right-contentBox">
                    <el-tag v-if="item.status == '0'" class="tag" size="mini" type="danger">未读</el-tag>
                    <div v-text="getHtmlText(item.content)" class="content"></div>
                  </div>
                  <div class="item-right-time">
                    {{ item.sendTime }}
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <div
                style="min-height: 200px;font-size: 18px;color: #909399;display: flex;justify-content: center;align-items: center;">
                <span class="el-icon-info" style="font-size: 22px;margin-right: 5px;"></span>
                暂无系统消息
              </div>
            </template>
          </el-tab-pane>
        </el-tabs>
        <div style="text-align: center;">
          <el-button type="text" @click="goMessageCenter">更多消息</el-button>
        </div>
      </div>
      <div slot="reference" class="bellBox">
        <!-- <el-badge :value="messageWaitReadNum" :max="99" :hidden="!messageWaitReadNum" class="item">
				  <div  :class="isHover? 'el-icon-message-solid' : 'el-icon-bell'" @mouseover="isHover=true" @mouseout="isHover=false"></div>
				</el-badge> -->
        <el-badge :value="messageWaitReadNum" :max="99" :hidden="!messageWaitReadNum">
          <slot name="trigger"></slot>
        </el-badge>

      </div>
    </el-popover>

    <messageDialog v-model="messageDetailDialog" :messageProp="selectMessageRow"></messageDialog>
    <noticeDialog></noticeDialog>
  </div>
</template>

<script>
import messageCenterApi from "@/api/system/messageCenter/messageCenter"
import messageDialog from '@/components/MessageBell/messageDialog'
import noticeDialog from '@/components/MessageBell/noticeDialog'
import { mapActions } from 'vuex'

export default {
  name: "MessageBell",
  dicts: ["MESSAGE_TYPE"],
  components: { messageDialog, noticeDialog },
  data() {
    return {

      isHover: false,
      activeName: "toDo",
      timer: null,
      messageDetailDialog: false,



      selectMessageRow: {},
    }
  },
  created() {
    this.startTimer() // 启动定时任务
    this.timerFun()
  },
  beforeDestroy() {
    this.cancelTimer() //取消定时任务
  },
  computed: {
    messageWaitReadNum() {
      return this.$store.state.message.waitReadCount
    },
    toDoList() {
      return this.$store.state.message.toDoFiveList
    },
    busList() {
      return this.$store.state.message.busFiveList
    },
    sysList() {
      return this.$store.state.message.sysFiveList
    },
  },
  methods: {
    ...mapActions(["getMessageInfo", "markMessageHaveRead"]),
    // tab切换
    tabChange(tab) {

    },
    // 启动定时任务
    startTimer() {
      const time = 5 // 多长时间请求一次，单位分钟
      this.timer = setInterval(this.timerFun, time * 60 * 1000)
    },
    // 取消定时任务
    cancelTimer() {
      window.clearInterval(this.timer)
    },
    // 定时任务内容
    timerFun() {
      // 获取用户消息信息(可获取待读数量、todo、bus、sys前5条信息)
      this.getMessageInfo()
    },
    // 打开详情弹窗
    openMessageDeatilDialog(row) {
      this.selectMessageRow = row
      this.messageDetailDialog = true
      // 如果未读则标记为已读
      if (row.status == '0') {
        this.markMessageHaveRead(row.id, row.messageType)
      }
    },

    // 跳转消息中心
    goMessageCenter() {
      this.$router.push({ path: "/messageCenter" })
    },

    // 获取html的纯文本
    getHtmlText(htmlStr) {
      let span = document.createElement('span');
      span.innerHTML = htmlStr;
      return span.textContent || span.innerText;
    }
  },
}
</script>

<style scoped lang="scss">
/deep/ .el-badge {
  line-height: 1;

  .el-badge__content {
    top: 10px;
    right: 25px;
  }
}

.el-icon-bell,
.el-icon-message-solid {
  font-size: 22px;
  padding: 5px;
  cursor: pointer;
}

.el-icon-message-solid {
  color: #188EFF;
}

/deep/ .el-tabs__header {
  margin-bottom: 0;
}

.message-item {
  border-bottom: 1px solid #dcdfe6;
  padding: 10px 5px;
  cursor: pointer;
  display: flex;

  &:hover {
    transition: .3s;
    background-color: #f0f2f5;
  }

  &>span {
    width: 25px;
    padding-top: 2px;
    font-size: 18px;
  }

  .item-right {
    flex: 1;
    font-size: 12px;
    overflow-x: hidden;

    &-contentBox {
      display: flex;
      width: 100%;
      color: #909399;
      height: 20px;
      line-height: 20px;

      .tag {
        margin-right: 3px;
      }

      .content {
        flex: 1;
        white-space: nowrap;
        overflow-x: hidden;
        text-overflow: ellipsis;
      }
    }

    &-time {
      padding-top: 5px;
      color: #909399;
      // text-align: right;
    }

    // &::after {
    // 	content: "";
    // 	position: absolute;
    // 	bottom: 0;
    // 	right: 0;
    // 	height: 20px;
    // 	width: 30px;
    // 	background: linear-gradient(to right, transparent, #FFF);
    // }
  }
}

.icon-btn {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6B7280;
  cursor: pointer;
  transition: all 0.15s;
  position: relative;
}

.icon-btn:hover {
  background: #F3F4F6;
  color: #374151;
}

.badge {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 16px;
  height: 16px;
  background: var(--danger);
  color: var(--white);
  font-size: 10px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
